/**
 * Bidirectional phase navigation helpers — used to jump between the
 * Executive-Summary phase list and the Gantt / Milestone timelines and
 * trigger a 2.2 s pulse animation on the target(s).
 */

const HIGHLIGHT_CLASS = "phase-highlight";
const HIGHLIGHT_DURATION_MS = 2300;

function pulse(el) {
  if (!el) return;
  el.classList.remove(HIGHLIGHT_CLASS);
  // Force reflow so the same class re-triggers the animation
  // eslint-disable-next-line no-unused-expressions
  void el.offsetWidth;
  el.classList.add(HIGHLIGHT_CLASS);
  setTimeout(() => el.classList.remove(HIGHLIGHT_CLASS), HIGHLIGHT_DURATION_MS);
}

/** Jumps from Executive-Summary → Gantt + Milestone with synced highlight. */
export function jumpToTimeline(num) {
  if (typeof window === "undefined") return;
  const targets = [
    document.getElementById(`gantt-phase-${num}`),
    document.getElementById(`milestone-phase-${num}`),
  ].filter(Boolean);
  if (targets.length === 0) return;
  targets[0].scrollIntoView({ behavior: "smooth", block: "center" });
  targets.forEach(pulse);
}

/** Jumps from Gantt or Milestone → Executive-Summary phase with highlight. */
export function jumpToExecPhase(num) {
  if (typeof window === "undefined") return;
  const target = document.getElementById(`exec-phase-num-${num}`);
  if (!target) return;
  target.scrollIntoView({ behavior: "smooth", block: "center" });
  pulse(target);
}
